import React, { useEffect, useState } from 'react';
import { Spin, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { ssoLoginSuccess } from '@/api/auth/auth';
import { setUserToken } from '@/store';
import './index.scss';

const OMNICRM_URL = (process.env.REACT_APP_OMNICRM_URL || '').trim();
const DEV_OMNICRM_URL = 'https://hjscrm-royalcanin.dianpusoft.cn:10002/login';
const UAT_OMNICRM_URL = 'https://rccrm-uat.marschina.com/login';
const PROD_OMNICRM_URL = 'https://rccrm.marschina.com/home/homePage/page';

const CARD_LIST = [
  { key: 'royal', title: '皇家宠物管理后台', link: '/shopSelect' },
  { key: 'omnicrm', title: 'omnicrm' },
];

const SystemEntry: React.FC = () => {
  const navigate = useNavigate();
  const [ssoLoading, setSsoLoading] = useState(() => {
    if (typeof window === 'undefined') return false;
    return new URL(window.location.href).searchParams.has('code');
  });

  useEffect(() => {
    const exchangeSsoCode = async () => {
      if (typeof window === 'undefined') return;
      const url = new URL(window.location.href);
      const code = url.searchParams.get('code');
      const stateParam = url.searchParams.get('state') || '0';
      if (!code) {
        setSsoLoading(false);
        return;
      }

      try {
        const res = await ssoLoginSuccess({ code, state: stateParam });
        if (res?.code !== 200) {
          message.error(res?.msg || 'SSO登录失败，请重新登录');
          navigate('/login', { replace: true });
          return;
        }

        setUserToken(res.data.access_token, res.data.clientId);
        localStorage.setItem('accessType', res.data.accessType);

        url.searchParams.delete('code');
        const search = url.searchParams.toString();
        window.history.replaceState({}, '', `${url.pathname}${search ? `?${search}` : ''}`);
      } catch (error) {
        console.error(error);
        message.error('SSO登录失败，请重新登录');
        navigate('/login', { replace: true });
        return;
      } finally {
        setSsoLoading(false);
      }
    };

    exchangeSsoCode();
  }, [navigate]);

  const resolveOmnicrmUrlByDomain = () => {
    if (typeof window !== 'undefined') {
      const host = window.location.host.toLowerCase();
      if (host.includes('hjscrm-royalcanin.dianpusoft.cn')) return DEV_OMNICRM_URL;
      if (host.includes('rccrm-uat.marschina.com')) return UAT_OMNICRM_URL;
      if (host.includes('rccrm.marschina.com')) return PROD_OMNICRM_URL;
    }
    return OMNICRM_URL || UAT_OMNICRM_URL;
  };

  const handleEnterSystem = (cardKey: string, link?: string) => {
    if (ssoLoading) {
      message.info('SSO登录处理中，请稍候');
      return;
    }

    if (cardKey === 'omnicrm') {
      let targetUrl = resolveOmnicrmUrlByDomain();
      if (typeof window !== 'undefined') {
        const currentState = new URL(window.location.href).searchParams.get('state');
        if (currentState) {
          const jumpUrl = new URL(targetUrl, window.location.origin);
          jumpUrl.searchParams.set('fromSso', 'true');
          targetUrl = jumpUrl.toString();
        }
      }
      window.open(targetUrl, '_blank');
      return;
    }

    if (!link) {
      message.info('功能正在建设中，敬请期待');
      return;
    }

    if (/^https?:\/\/\S+/i.test(link)) {
      window.open(link, '_blank');
      return;
    }

    navigate(link);
  };

  return (
    <div className="system-entry-page">
      <Spin spinning={ssoLoading}>
        <div className="system-entry-wrapper">
          {CARD_LIST.map(card => (
            <div
              key={card.key}
              className={`system-entry-card system-entry-card--${card.key}`}
              onClick={() => handleEnterSystem(card.key, card.link)}></div>
          ))}
        </div>
      </Spin>
    </div>
  );
};

export default SystemEntry;
